module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/校园招募.b5d2e37e.png";